import { render } from "./InstructorsForm.vue?vue&type=template&id=5dc29a1c"
import script from "./InstructorsForm.vue?vue&type=script&lang=js"
export * from "./InstructorsForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__